<template>
  <div class="detail" v-if="contract">
    <van-nav-bar
      title="合同详情"
      left-arrow
      safe-area-inset-top
      @click-left="$router.go(-1)"
    />
    <div class="meta">
      <div class="name">{{ contract.product_name }}</div>
      <div class="sub">合同编号：{{ contract.contract_no }}</div>
      <van-tag v-if="contract.settled" type="success" style="margin-top:8px">已结清</van-tag>
    </div>
    <div v-if="contract.settled" class="cert-entry">
      <van-button round block type="info" @click="$router.push(`/settle-cert/${contract.id}`)">
        查看结清证明
      </van-button>
    </div>

    <div class="paper">
      <pre class="content">{{ bodyContent }}</pre>

      <div class="sign-area">
        <div class="lender-line">
          <span class="lab">出借人（盖章）：</span>
          <span class="name-txt">安享花金融服务有限公司</span>
          <company-seal class="stamp" :size="108" />
        </div>
        <div class="borrower-line">
          <span class="lab">借款人（签字）：</span>
          <span class="name-txt">{{ displayBorrower }}</span>
        </div>
        <div class="date-line">签署日期：{{ contract.start_date || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { contractDetail, agreeContract } from '@/api/request.js'
import CompanySeal from '@/components/CompanySeal.vue'

export default {
  name: 'ContractDetail',
  components: { CompanySeal },
  data() {
    return {
      contract: null,
      borrowerName: ''
    }
  },
  computed: {
    displayBorrower() {
      return this.contract?.user_name || this.borrowerName || ''
    },
    bodyContent() {
      const raw = String(this.contract?.content || '')
      // 去掉文末签署段，改由下方签署区统一展示并盖章
      return raw
        .replace(/\n*出借人（盖章）[：:][\s\S]*$/, '')
        .replace(/示例小贷有限公司/g, '安享花金融服务有限公司')
        .trim()
    }
  },
  methods: {
    async load() {
      const info = JSON.parse(localStorage.getItem('user_info') || '{}')
      this.borrowerName = info.name || ''
      const res = await contractDetail(this.$route.params.id)
      this.contract = res.data
      if (this.contract && !this.contract.agreed) {
        try {
          await agreeContract(this.$route.params.id)
          this.contract.agreed = true
        } catch (e) {
          // ignore
        }
      }
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/public";
.detail {
  min-height: 100%;
  background: #fff;
  padding-bottom: .6rem;
  .van-nav-bar {
    background-image: linear-gradient(to right, #6aa8f5, #3d8aef);
    /deep/ .van-nav-bar__title, /deep/ .van-icon { color: #fff; }
  }
  .meta { padding: .3rem .3rem 0; }
  .name { font-size: .36rem; font-weight: 700; }
  .sub { margin: .12rem 0 .16rem; color: #888; font-size: .26rem; }
  .cert-entry {
    margin: .2rem .3rem .1rem;
  }
}
.paper {
  margin: .24rem;
  padding: .3rem;
  background: #f7f8fa;
  border-radius: .16rem;
}
.content {
  white-space: pre-wrap;
  font-family: inherit;
  line-height: 1.7;
  margin: 0;
  font-size: .28rem;
  color: #333;
}
.sign-area {
  margin-top: 18px;
  padding-top: 8px;
  border-top: 1px dashed #ddd;
}
.lender-line {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 96px;
  padding: 8px 100px 8px 0;
  font-size: 14px;
  color: #333;
  .lab { color: #666; }
  .name-txt { font-weight: 600; }
}
.stamp {
  position: absolute !important;
  left: 88px;
  top: 50%;
  transform: translateY(-52%);
  z-index: 2;
}
.borrower-line {
  margin-top: 6px;
  font-size: 14px;
  color: #333;
  .lab { color: #666; }
  .name-txt { font-weight: 600; }
}
.date-line {
  margin-top: 12px;
  text-align: right;
  font-size: 13px;
  color: #666;
}
</style>
